import { FunctionComponent } from "react";

import useTypedContext from "hooks/useTypedContext";
import Box from "ds/components/Box";
import IconEmphasized from "ds/components/IconEmphasized";
import TileTitle from "ds/components/Tile/Title";
import TileDescription from "ds/components/Tile/Description";
import BadgeNext from "ds/components/BadgeNext";
import TileWrapperButton from "ds/components/Tile/Wrapper/Button";

import { ModuleFormContext } from "../context";
import { ModuleCreationWizardStep } from "../types";

type NewModuleIntermediateConfirmationStepTileProps = {
  hasCopiedConfiguration: boolean;
  icon: FunctionComponent;
  title: string;
  description: string;
  action: {
    step: ModuleCreationWizardStep;
    title: string;
  };
};

const NewModuleIntermediateConfirmationStepTile = ({
  hasCopiedConfiguration,
  icon: Icon,
  title,
  description,
  action,
}: NewModuleIntermediateConfirmationStepTileProps) => {
  const { setCurrentStep, setIsIntermediateStepActive } = useTypedContext(ModuleFormContext);
  const actionHandler = () => {
    setIsIntermediateStepActive(false);
    setCurrentStep(action.step);
  };

  const isDefined =
    hasCopiedConfiguration &&
    (action.step === ModuleCreationWizardStep.Behavior ||
      action.step === ModuleCreationWizardStep.Share);

  return (
    <TileWrapperButton onClick={actionHandler}>
      <Box align="start" justify="between" fullWidth>
        <Box align="center" grow="1" gap="medium">
          <IconEmphasized icon={Icon} />

          <Box direction="column" gap="small">
            <TileTitle>{title}</TileTitle>
            <TileDescription>{description}</TileDescription>
          </Box>
        </Box>
        {isDefined && <BadgeNext variant="green" type="strong" text="DEFINED" />}
      </Box>
    </TileWrapperButton>
  );
};

export default NewModuleIntermediateConfirmationStepTile;
